<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_region.edit_title') + (region ? (` : ${region.name}`) : '')"
           fixed-tabs>
    <template #content>
      <v-container class="edit-region-content pa-0" fluid v-if="region">
        <v-tabs fixed-tabs
                v-model="tabIndex">
          <v-tab>{{ $t('register.basic_info') }}</v-tab>
          <v-tab-item>
            <v-container class="overflow-y-scroll" fluid>
              <v-form ref="regionForm">
                <v-text-field readonly
                              :label="$t('admin_acc_region.location')"
                              v-model="region.location.name"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              :label="$t('admin_acc_region.name_en')"
                              v-model="region.name_en"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              :label="$t('admin_acc_region.name_zh')"
                              v-model="region.name_zh"
                              :rules="requiredRules"></v-text-field>
              </v-form>
            </v-container>
          </v-tab-item>

          <v-tab>{{ $t('admin_acc_item.title') }}</v-tab>
          <v-tab-item>
            <ItemList full-height
                      :region-id="regionId"
                      :refresh-trigger.sync="itemRefreshTrigger"
                      @edit="onItemEdit"
                      v-if="tabIndex === 1"></ItemList>

            <EditItemModal :item-id="editingItemId"
                           :shown="editItemModalShown"
                           @cancel="onEditItemModalFinish"></EditItemModal>
          </v-tab-item>

          <v-tab>{{ $t('admin_acc_region.exclusion') }}</v-tab>
          <v-tab-item>
            <v-container class="overflow-y-scroll" fluid>
              <ExclusionGrid :region-id="regionId"></ExclusionGrid>
            </v-container>
          </v-tab-item>

        </v-tabs>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.regionForm.validate() && saveRegion()"
               v-if="tabIndex === 0">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import RegionList from "@/components/acc_booking/region/RegionList";
import ItemList from "@/components/acc_booking/item/ItemList";
import ExclusionGrid from "@/components/acc_booking/ExclusionGrid";
import EditItemModal from "@/components/acc_booking/item/EditItemModal";

export default {
  name: 'EditRegionModal',
  components: {EditItemModal, ExclusionGrid, ItemList, RegionList, BGModal},
  props: {
    regionId: String,
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);
    const cancel = function () {
      emit('cancel');
    };

    const tabIndex = ref(0);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getRegion()
        }
      }

      tabIndex.value = 0;
    });

    const region = ref(null);
    const getRegion = function () {
      root.$callAPI('aafb/admin/region/', {region_id: props.regionId}, function (response) {
        region.value = response.body.region;
      });
    }

    // Info
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const saveRegion = function () {
      root.$callAPI('aafb/admin/region/set/', {
        ...region.value,
        region_id: props.regionId,
      }, () => {
        root.$showAlertMessage('Info Saved');
        getRegion()
      })
    }

    //
    const itemRefreshTrigger = ref(false);
    const editingItemId = ref(null);
    const editItemModalShown = ref(false);
    const onItemEdit = function (item) {
      editingItemId.value = item.id;
      editItemModalShown.value = true;
    };
    const onEditItemModalFinish = function () {
      itemRefreshTrigger.value = true;
      editingItemId.value = null;
      editItemModalShown.value = false;
    }

    return {
      dialogShown,
      cancel,

      tabIndex,

      region,
      requiredRules,
      saveRegion,

      itemRefreshTrigger,
      editingItemId,
      editItemModalShown,
      onItemEdit,
      onEditItemModalFinish,
    }
  }
}
</script>

<style lang="less">
.edit-region-content {
  display: flex;
  height: 100%;
}
</style>
